module.exports = __webpack_public_path__ + "sv.2a44c3241d00a7e69879.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/sv.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/sv.svg
// module chunks = styles